import React from "react";
import { Outlet, useLocation, useSearchParams } from "react-router-dom";
import { privateRoutes } from "../routes/routesPath";
import useWindowDimensions from "../hooks/useWindowDimensions";
import Header from "../Component/Header/Header";
import Footer, { SubFooter } from "../Component/Footer/Footer";
import BottomTab from "../Component/mobileBottomTab/bottomTab";

export default function MainTheme({ initialData = {}, children, renderChildren }) {
  const { width } = useWindowDimensions();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const receiver = searchParams.get("receiver");

  return (
    <div className="mainWrapper position-relative">
      {receiver && width < 576 ? "" : <Header />}
      <main className="mainBody">{renderChildren ? children : <Outlet />}</main>
      {privateRoutes.chatRoute !== pathname && <SubFooter initialData={initialData} />}
      <Footer />
      <BottomTab />
    </div>
  );
}
